import Cookies from "js-cookie";

const setItem = (key, value) => {
  localStorage.setItem(key, String(value));
};

const setObjectInLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const getItem = (key) => {
  const val = localStorage.getItem(key);
  return val ? JSON.parse(val) : null;
};

const getSingleItem = (key) => {
  return localStorage.getItem(key);
};

const removeItem = (key) => {
  localStorage.removeItem(key);
};

const setToken = (token) => {
  Cookies.set("s_token", token, { expires: 1 });
};

const getToken = () => {
  return Cookies.get("s_token") || null;
};

const removeToken = () => {
  Cookies.remove("s_token");
};

export {
  setItem,
  getItem,
  getSingleItem,
  setObjectInLocalStorage,
  removeItem,
  setToken,
  getToken,
  removeToken,
};
